export default __webpack_public_path__ + "static/media/Orman.ee03f469.svg";